import { ContentOnexOne } from "./styles";
import ContentImage from "@/shared/ContentImage";
import ContentTitle from "@/shared/ContentTitle";
import { NormalArticle } from "@/widgets/Nota/Templates/stylesModulesGenericNormal.js";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import VideoLoop from "@/shared/VideoLoop";
import { clickContent } from "@/shared/Analitics/GoogleAnalytics4";
import MAM from "@/shared/MAM";
import useNewsDataModules from "@/hooks/useNewsDataModules";
import { getHourMinutes, getMonthDayYear } from "helpers";
import Streaming from "@/shared/Streaming";
import { GenericNormalSkeleton } from "@/shared/Skeleton";
import JWPlayer from "@/shared/JWPlayer";

const OnexOne = (props) => {
  let streaming = Object.keys(props)?.filter((key) => /^streaming_/.test(key));
  if (streaming?.length > 0) {
    streaming = {
      link: props?.streaming_link,
      mute: props?.streaming_mute,
      autoplay: props?.streaming_autoplay,
    };
  } else {
    streaming = null;
  }

  const clippings = {
    desktop: ["rectangle_sm", "16_9_medianas", "2_1_S2"],
    mobile: ["rectangle_lg", "rectangle_sm", "16_9_medianas", "2_1_S2"],
  };

  if (props?.selectedClippingId) {
    clippings.desktop = [props.selectedClippingId, ...clippings.desktop];
    clippings.mobile = [props.selectedClippingId, ...clippings.mobile];
  }

  const {
    _id,
    asPath,
    author = [],
    authorSignature,
    children,
    containerName,
    cutTitle = false,
    iconMultimedia,
    image,
    imagePreview,
    imageWeb,
    isPreview,
    mams,
    payWallExclusive,
    publishedDate,
    section = [],
    showDate = false,
    subtitle,
    title,
    url,
    urlTarget,
    videosOpenLoop,
    videoLoop,
    loading = false,
    displayTitle,
    videoLoopFlavors = []
  } = useNewsDataModules({ ...props }, clippings);
  let date = true;
  if (publishedDate) {
    const publicationDate = new Date(publishedDate);
    const currentDate = new Date();
    if (getMonthDayYear(publicationDate) != getMonthDayYear(currentDate)) {
      date = getMonthDayYear(publishedDate);
    } else {
      date = getHourMinutes(publishedDate);
    }
  }

  return (
    loading ? <GenericNormalSkeleton/> :
    <>
      <NormalArticle
        suppressHydrationWarning
        className={`${
          !streaming
            ? "normal-article-nota"
            : "normal-article-streaming-onexone"
        }`}
      >
        <ContentOnexOne className="onexone" mamsEnabled={mams?.enabled}>
          {children}

          <ContentTitle
            _id={_id}
            type="onexone"
            section={section}
            author={author}
            authorSignature={authorSignature}
            title={displayTitle ? displayTitle : title}
            subtitle={subtitle}
            payWallExclusive={payWallExclusive}
            date={date}
            dateHours={true}
            cutTitle={cutTitle}
            showDate={showDate}
            contentType={props.contentType}
          />
            {props.type === "videos2" ? (
              <JWPlayer
                id={`OnexOne-${props.entityId || Math.random().toString(36).substr(2, 9)}`}
                entityId={props.entityId}
                thumbnail={props.thumbnail}
                title={props.name || props.title}
                configType="rectangle"
                isPreview={isPreview}
              />
            )
          : videosOpenLoop?.enabled ? (
            <VideoLoop videoLoop={videoLoop} width={"640"} videoLoopFlavors={videoLoopFlavors}/>
          ) :!streaming ? (
            <picture>
              {mams?.enabled && (
                <MAM
                  sport={mams.deporte}
                  match={mams.idPartido}
                  type="home"
                  isPreview={isPreview}
                />
              )}
              {isPreview ? (
                imagePreview && (
                  <ContentImage
                    iconMultimedia={iconMultimedia}
                    data={imagePreview}
                    alt={title}
                  />
                )
              ) : (
                <ContentImage
                  iconMultimedia={iconMultimedia}
                  data={imageWeb}
                  alt={title}
                  image={image}
                />
              )}
            </picture>
          ) : (
            <Streaming {...streaming} />
          )}
          <LinkAbsolute
            suppressHydrationWarning
            href={url}
            target={urlTarget}
            aria-label={title}
            onClick={() =>
              clickContent(
                { contentType: title, contentList: containerName },
                url,
                asPath
              )
            }
          />
        </ContentOnexOne>
      </NormalArticle>
    </>
  );
};

export default OnexOne;
